module.exports = __webpack_public_path__ + "mainassets/img/envelope-open-green.342857b0.svg";